var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-user-agreement', {
    attrs: {
      "active": _vm.userAgreement
    },
    on: {
      "close": _vm.hideModal
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95f9fd66","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modal/ModalUserAgreement/ModalUserAgreementContainer.vue
// module id = 1212
// module chunks = 0